<!--
    校区管理-分校管理-授权课件
    功能：分校授权课件
    说明：旧版
-->
<template>
  <div class="courseware">
    <div class="total">
      <span>XXX校区</span>
      <span>授权课件数<b>30</b></span>
      <span>互动课件<b>25</b></span>
      <span>云盘课件<b>5</b></span>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="互动课件授权" name="first">
        <AppList
          ref="list"
          :list.sync="list"
          title=""
          api="/department">
          <AppSearch
            v-if="checkPermission('index')"
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArr"/>
          <template v-if="checkPermission('index')" slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                type="selection"
                width="55" />
              <el-table-column
                v-for="column in columns"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
<!--      <el-tab-pane label="云盘资源授权" name="second">云盘资源授权</el-tab-pane>-->
    </el-tabs>
    <div class="btn">
      <el-button type="primary" @click="onSubmit">确认授权</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  export default {
    name: "courseware",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id,
        activeName: 'first',
        list: {}
      }
    },
    computed: {
      columns() {
        return [
          { prop: 'name', label: '课件名称' },
          { prop: 'name', label: '课件标题' },
          { prop: 'name', label: '课件目录' },
          { prop: 'name', label: '教学内容' },
          { prop: 'name', label: '更新时间' },
        ];
      },
      searchArr() {
        const column = [
          { prop: 'name', label: '课件名称' },
          { prop: 'phone', label: '课件目录' }
        ];
        return [
          {
            selectValue: [
              { value: 0, name: '已授权' },
              { value: 1, name: '未授权' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'is_auth_minipro',
            placeholder: '请选择授权状态'
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
    },
    methods: {
      // 权限
      checkPermission(key, text) {
        return this.$permissions(`system.department.${key}`, text);
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 确认授权
      onSubmit() {
        console.log(1)
      }
    }
  }
</script>

<style scoped lang="scss">
.courseware {
  .total {
    text-align: right;
    font-size: 16px;
    color: var(--color-primary);
    span {
      margin: 0 10px;
      b {
        margin: 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BranchSchool/courseware.vue